import "./index.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar";

// ── Inline SVG icons ─────────────────────────────────────────────────────────
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" fill="#dcfce7" stroke="#16a34a" />
    <path
      d="M7 13l3 3 7-7"
      stroke="#16a34a"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconShield = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill={color}>
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
  </svg>
);

const IconCard = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
  </svg>
);

const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
  </svg>
);

const IconDocument = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15h8v2H8zm0-4h8v2H8z" />
  </svg>
);

const IconHome = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </svg>
);

// ── Component ─────────────────────────────────────────────────────────────────
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentTime, setPaymentTime] = useState("");

  useEffect(() => {
    const now = new Date();
    setPaymentDate(
      now.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    );
    setPaymentTime(
      now.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    );
  }, []);

  // const redirectURL = () =>{
  //   window.lo
  // }

  return (
    <>
      <Topbar />
      <div className="ps-page">
        <div className="ps-card">
          {/* ── Success area ── */}
          <div className="ps-success-area">
            <div className="ps-success-icon">
              <IconCheck />
            </div>

            <h2 className="ps-title">Payment Successful!</h2>
            <p className="ps-subtitle">
              Your protection plan is now active. A confirmation has been sent
              to your registered email.
            </p>

            {/* Steps */}
            <div className="ps-steps">
              <div className="ps-steps__icon" style={{ color: "#0d2f6c" }}>
                <IconShield />
              </div>
              <div className="ps-steps__line" />
              <div className="ps-steps__icon" style={{ color: "#0d2f6c" }}>
                <IconCard />
              </div>
              <div className="ps-steps__line" />
              <div
                className="ps-steps__icon"
                style={{ background: "#dcfce7", color: "#16a34a" }}
              >
                <IconCheck />
              </div>
            </div>
          </div>

          {/* ── Bottom panel ── */}
          <div className="ps-bottom">
            <p className="ps-bottom-title">Transaction Details</p>

            <div className="ps-detail-grid">
              <div className="ps-detail-item">
                <div className="ps-detail-item__icon">
                  <IconCalendar />
                </div>
                <div className="ps-detail-item__label">Date</div>
                <div className="ps-detail-item__value">
                  {paymentDate || "—"}
                </div>
              </div>

              <div className="ps-detail-item">
                <div className="ps-detail-item__icon">
                  <IconClock />
                </div>
                <div className="ps-detail-item__label">Time</div>
                <div className="ps-detail-item__value">
                  {paymentTime || "—"}
                </div>
              </div>

              <div className="ps-detail-item">
                <div className="ps-detail-item__icon">
                  <IconShield color="#93c5fd" />
                </div>
                <div className="ps-detail-item__label">Status</div>
                <div className="ps-detail-item__value">Protected ✓</div>
              </div>

              <div className="ps-detail-item">
                <div className="ps-detail-item__icon">
                  <IconDocument />
                </div>
                <div className="ps-detail-item__label">Policy</div>
                <div className="ps-detail-item__value">Active</div>
              </div>
            </div>

            <a
              className="ps-home-btn"
              // onClick={
              // redirectURL
              // navigate("https://www.gadgets360shield.com/products")
              // }
              href="https://www.gadgets360shield.com/products"
            >
              <IconHome />
              Go to Home
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
